module.exports = __webpack_public_path__ + "img/crossed-reload.3e6b731.svg";